import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative-position width-auto self-start base-margin-right" }

import { computed } from 'vue';

import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { AvailableIconSizes, KnowFileExtensions } from 'SharedDir/constants/attachments';

type IconSize = (typeof AvailableIconSizes)[number];


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ExtensionIcon' },
  __name: 'ExtensionIcon',
  props: {
    size: { default: 'medium' },
    extension: { default: 'docx' }
  },
  setup(__props: any) {



const props = __props;

const iconName = computed(() => {
  const extension = props.extension?.toLowerCase();
  if (extension && KnowFileExtensions.includes(extension)) {
    return `custom:/files/${extension}`;
  }
  return 'custom:/files/unknown';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SIcon, {
      size: _ctx.size,
      name: iconName.value
    }, null, 8, ["size", "name"])
  ]))
}
}

})